import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./navbar.scss";

import logo from "../../../Assets/images/aron-logo.png";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(window.scrollY);
  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    const offset = currentScrollPos;

    if (offset > 280) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }

    // Hide navbar and dropdown when scrolling up, show when scrolling down
    const isScrollingDown = prevScrollPos > currentScrollPos;
    setVisible(isScrollingDown || currentScrollPos < 10);

    if (!isScrollingDown) {
      setShowMenu(false); // Close dropdown when scrolling up
    }

    setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos, visible]);

  return (
    <nav
      className={`main-navbar ${scrolled ? "dark-nav" : ""} ${
        visible ? "visible" : "hidden"
      }`}
    >
      <Link to="/" className="main-navbar-left">
        <img src={logo} alt="Logo" style={{ marginTop: "50px" }} />
      </Link>

      <div className="main-navbar-right">
        <div className="menu-toggle" onClick={toggleMenu}>
          <div className={`toggle ${showMenu ? "active" : ""}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <ul className={`nav-links ${showMenu ? "active" : ""}`}>
          <li>
            <NavLink className="nav-link" to="/">
              HOME
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/aboutpage">
              OUR VALUES
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/services">
              SERVICES
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/portfolio">
              PROJECTS
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/events">
              EVENTS
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/careers">
              CAREER
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/contactpage">
              CONTACT
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
